import mappingActivity from './mapping-activity-en';
/**
 * English Localization
 */

export default {
  mappingActivity,
  // CR-0068: spec/frontend/ui-dictionary.md, first complete mapping path.
  mapping: {
    // frontend-class-mappings-R49; spec/frontend/ui-dictionary.md (CR-0073).
    enumTargetUnavailable: "Mapping is unavailable for an enumeration.",
    contextHelp: {
      name: "The dataset name on its tab. Several datasets can use the same source table.",
      description: "Which tables and conditions form the dataset: joins, filters and grouping. Use {'@'} to insert a reference.",
      sourceSelection: "Read the entire dataset on every run or only changes since the previous load.",
      initial: "Selection condition for the first run, before any previous load.",
      subsequent: "Selection condition for later runs. For example, modification date later than the last successful load.",
      businessWrite: "Add new records, update existing records by key, or replace all data.",
      deletions: "Whether source deletion flags should be reflected in the business model.",
    },
    tablesAndColumns: "Tables and columns",
    createNameHint: "For example, Orders with line items",
    createDescriptionHint: "Describe the dataset. {'@'} — tables and columns",
    editDescriptionHint: "Describe tables, joins, filters and grouping. {'@'} — a source reference",
    descriptionHelp: "Describe one table or a dataset combining several tables.",
    loadHelp: "Selection defines the data for STAGE. Writing updates the business layer.",
    editDataset: "Edit dataset {dataset}",
    editLoad: "Edit load {dataset}",
    loadParameters: "Load parameters",
    sourceSelection: "Source selection",
    businessWrite: "Write to business layer",
    deletions: "Deleted records",
    selectionOptions: { full: "Full", incremental: "Incremental" },
    writeOptions: { upsert: "Add and update (upsert)", insert: "Add only (insert)", replace: "Replace all (truncate + insert)" },
    deletionOptions: { ignore: "Do not process", flag: "Use deletion flag" },
    conditionSummary: "{value} {comparison} {operand} → «{then}», otherwise «{otherwise}»",
    preview: "In the mapping",
    onDate: "as of",
    listParameter: "List",
    details: "Template, errors and additional parameters",
    done: "Done",
    close: "Close",
    list: "List value",
    relation: "Via relation",
    condition: "Condition",
    constant: "Constant",
    empty: "Not populated",
    rule: "Rule",
    sourceSystem: "Source system",
    globalSystem: "Global",
    currentDatasetSystem: "Current dataset system",
    atDate: "As of date",
    dateHint: "Not specified — current value",
    formExpressionHint: "Text or formula; {'@'} — column",
    listMode: "Value source",
    recoding: "Recoding table",
    value: "Value",
    reason: "Reason",
    path: "Relation path",
    comparison: "Comparison",
    operand: "Compare with",
    then: "Then",
    otherwise: "Otherwise",
    onEmpty: "If empty",
    onNotFound: "If not found",
    onDuplicateKey: "If key repeats",
    listModes: { expression: "Expression or column", constant: "Fixed value", recoding: "Recoding table" },
    comparisons: { greater: "greater than", equal: "equals", less: "less than" },
    policyValues: { leaveEmpty: "Leave empty", skipRecord: "Skip record", stopLoad: "Stop load", first: "Take first record", last: "Take last record" },
    more: "⋯",
    datasetActions: "Actions for mapping {dataset}",
    deleteDataset: "Delete mapping",
    deleteConfirmation: "Delete mapping?",
    deleteWarning: "The dataset description, field rules and load settings will be deleted. Source tables and the class will remain.",
    load: "Load",
    conditions: "Selection conditions",
    initial: "Initially",
    subsequent: "Subsequent loads",
    subsequentSummary: "Then",
    selection: { full: "Full selection", incremental: "Incremental selection" },
    writeMode: { upsert: "Add and update", insert: "Add only", replace: "Replace all" },
    deletedRecords: { ignore: "Ignore deletions", flag: "Track deletion flag" },

    lookup: "Lookup by key",
    lookupDescription: "Class · lookup field · expression",
    listDescription: "List · value or recoding",
    relationDescription: "Path to a related field",
    conditionDescription: "If · then · else",
    constantDescription: "Fixed value",
    emptyDescription: "Intentional empty value with a reason",
    template: "Template",
    templateHelp: "A ready-made way to populate a field. Defines the rule structure; its parameter values can be changed.",
    lookupKeysHelp: "Tab — next parameter; Enter — finish; Esc — cancel unfinished input.",
    searchClassHelp: "The business-model class to search for a record in. For example, find a Customer by a source code and store its reference. This is not a source-data table.",
    searchFieldHelp: "The field of the selected class to compare with the lookup value. For example, the Code field of the Customer class.",
    searchValueHelp: "What to look for in the selected class. For example, {'@'}tx_sales.cust_cd is a customer code from the source. A formula can use multiple columns.",
    text: "Annotated text",
    in: "in",
    by: "by",
    searchClass: "Lookup class",
    searchField: "Lookup field",
    searchValue: "Lookup value",
    classHint: "class",
    fieldHint: "lookup field",
    expressionHint: "{'@'}column or formula",
    ruleHint: "Text, {'@'} — column, / — template",
    editing: "Editing {field}",
    cancelInput: "Cancel unfinished input (Esc)",
    templates: "Templates",
    nothingFound: "Nothing found",
    editValue: "Edit {field} · {dataset}",
    notSet: "Not set",
    referenceNotFound: "Reference not found",
    key: "Key",
    technicalFields: "Technical fields",
    technicalNames: "Technical names",
    currentLoadTime: "Load time",
    previousLoadTime: "Previous load",
    effectiveFrom: "Effective from",
    notSaved: "Not saved",
    changing: "Changing…",
    saved: "Saved",
    untitled: "Untitled",
    retry: "Retry",
    saveFailed: "Could not save the change",
    revisionConflict: "The mapping has changed. The action was not performed.",
    datasets: "Datasets",
    all: "All",
    addDataset: "Add dataset",
    plus: "＋",
    dataset: "Dataset",
    findField: "Find field",
    onlyEmpty: "Only unfilled",
    field: "Field",
    noFields: "No fields match the filter",
    noDatasets: "No mappings yet",
    addHelp: "Add a dataset to fill the class fields.",
    name: "Name",
    description: "How it is formed",
    cancel: "Cancel",
    add: "Add",
  },


  /**
   * Generic failure texts, keyed by machine-readable cause.
   * Norm: spec/backend/invariants/api-errors.md (R04, R06-R08).
   * Zone-specific causes are looked up first: `<zone>.errors.<code>`.
   */
  errors: {
    INTERNAL_ERROR: 'Product failure. Try again later',
    NOTE_FORMAT_NOT_MARKDOWN: 'Notes are stored as Markdown. Remove the HTML markup (tag "{tag}") — to show it as an example, put it in code',
    NOT_FOUND: 'Object not found',
    // A typo in the request stays distinguishable from "object does not exist"
    // (invariants/api-errors).
    INVALID_ID: 'Invalid identifier: "{id}"',
    INVALID_LIMIT: 'Invalid record count: "{limit}"',
    // Malformed request: the product names the filter parameter or the data
    // field the action was rejected over (api-errors-R06, R07). The name may be
    // absent — the unnamed variant of the text (`_UNNAMED`) is used then.
    QUERY_PARAM_UNKNOWN:
        'The request carries a filter parameter "{param}" the product does not accept. Reload the page and retry',
    QUERY_PARAM_UNKNOWN_UNNAMED:
        'The request carries a filter parameter the product does not accept. Reload the page and retry',
    QUERY_PARAM_MISSING:
        'The request is missing the required filter parameter "{param}". Reload the page and retry',
    QUERY_PARAM_MISSING_UNNAMED:
        'The request is missing a required filter parameter. Reload the page and retry',
    QUERY_PARAM_INVALID:
        'The value of the filter parameter "{param}" is not allowed. Change the filter and retry',
    QUERY_PARAM_INVALID_UNNAMED:
        'The value of one of the filter parameters is not allowed. Change the filter and retry',
    BODY_INVALID:
        'The product could not read the submitted data. Reload the page and retry — if the failure repeats, tell your administrator',
    BODY_FIELD_UNKNOWN:
        'The submitted data carries a field "{field}" the product does not accept. Reload the page and retry',
    BODY_FIELD_UNKNOWN_UNNAMED:
        'The submitted data carries a field the product does not accept. Reload the page and retry',
    BODY_FIELD_MISSING:
        'The submitted data is missing the required field "{field}". Fill it in and retry',
    BODY_FIELD_MISSING_UNNAMED:
        'The submitted data is missing a required field. Fill in the required fields and retry',
    BODY_FIELD_INVALID:
        'The value of the field "{field}" is not allowed. Correct it and retry',
    BODY_FIELD_INVALID_UNNAMED:
        'The value of one of the fields is not allowed. Check the entered data and retry',
    METHOD_NOT_ALLOWED: 'This action is not supported for this address',
    UNKNOWN_ERROR: 'The action could not be completed',
    NETWORK_ERROR: 'No connection to the server. Check your network and retry',
    LOAD_FAILED: 'Failed to load data',
    CREATE_FAILED: 'Failed to create',
    UPDATE_FAILED: 'Failed to update',
    DELETE_FAILED: 'Failed to delete',
    // An archived commit is read-only
    // (spec/backend/business-model/versioning.md, R25).
    FEATURE_IS_ARCHIVED_COMMIT: 'This is an archived commit — its content is read-only. Switch to the current version of the feature',
    // Project name: non-empty and unique
    // (spec/backend/administration/projects.md, R04; spec/backend/invariants/naming.md).
    PROJECT_NAME_EMPTY: 'Project name cannot be empty',
    // Feature deletion holds
    // (spec/backend/business-model/feature-lifecycle.md, R13).
    FEATURE_HELD_BY_DESCENDANTS:
        'The feature has branches ({descendants}) and cannot be deleted while they exist',
    FEATURE_HELD_BY_DATAMARTS:
        'The feature contains datamarts ({datamarts}) and datamart folders ({folders}) and cannot be deleted while they exist. To hide the feature and keep its content, archive it',
    PROJECT_NAME_EXISTS: 'A project named "{name}" already exists',
    // Feature name: non-empty after normalisation
    // (spec/backend/business-model/feature-lifecycle.md, R05).
    FEATURE_NAME_EMPTY: 'Enter a feature name',
    FEATURE_NAME_EXISTS: 'A feature named "{name}" already exists in the project',
    FEATURE_STATUS_INVALID: 'Invalid feature status: "{status}". Allowed: {allowed}',
    // Переданное название ветки, пустое после нормализации, — отказ
    // (spec/backend/business-model/versioning.md, business-model-versioning-R30).
    BRANCH_NAME_EMPTY: 'Branch name cannot be empty',
    // The encryption key has changed: source secrets are still encrypted with
    // the previous key and can no longer be read. The user must see the cause
    // and the way out (spec/backend/invariants/encryption.md, R06, R07).
    ENCRYPTION_KEY_MISMATCH:
        'The connection secret was encrypted with a previous encryption key and can no longer be read. Enter the secret again and save the source',
    // Metadata sync/profiling failure: cause and params arrive machine-readable
    // (api-errors-R06, R07), not as a free-form string
    // (spec/notes/archive/bugs/2026-08-10_17-30_sync-history-drops-failure-reason.md).
    SOURCE_ERROR: 'The source is unavailable or rejected the request. Check the source and retry later',
    SYNC_TIMEOUT: 'Sync did not finish within the time limit ({seconds}s)',
    SYNC_FAILED: 'Sync failed',
    PROFILING_TIMEOUT: 'Profiling did not finish within the time limit ({seconds}s)',
    PROFILING_FAILED: 'Profiling failed',
    HTTP_400: 'Request rejected: invalid data',
    HTTP_401: 'Session expired. Please sign in again',
    // api-errors-R04/R08; rbac-R13.
    ACCESS_DENIED: 'You do not have permission to perform this action',
    HTTP_403: 'You do not have permission to perform this action',
    HTTP_404: 'Object not found',
    HTTP_409: 'The action conflicts with the current state',
    HTTP_422: 'Request rejected: invalid data',
    HTTP_500: 'Product-side failure. Please retry later',
    HTTP_502: 'Product-side failure. Please retry later',
    HTTP_503: 'The product is temporarily unavailable. Please retry later',
  },
  common: {
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    loading: 'Loading...',
    close: 'Close',
    details: 'Details',
    actions: 'Actions',
    name: 'Name',
    description: 'Description',
    required: 'Required',
    rename: 'Rename',
    admin: 'Admin',
    saveSuccess: 'Saved successfully',
    saveError: 'Failed to save',
    noteNotLoaded: 'Note is not loaded — editing is unavailable. Please retry',
    loadError: 'Failed to load data',
  },
  
  app: {
    title: 'MetaBridge',
    menu: 'Menu',
  },
  
  nav: {
    mappings: 'Mappings',
    sourceExplorer: 'Source Explorer',
    businessLayer: 'Business Layer',
    etl: 'ETL',
    admin: {
      users: 'Users',
    },
  },
  
  project: {
    createStandalone: 'create project',
    select: 'Project',
    create: 'Create New Project...',
    createTitle: 'Create New Project',
    name: 'Project Name',
    namePlaceholder: 'My Project',
    description: 'Description',
    descriptionPlaceholder: 'Project description (optional)',
    created: 'Project "{name}" created!',
    loadError: 'Failed to load projects list',
    createError: 'Failed to create project',
    // Проект из ссылки не существует либо не виден актору — одно и то же
    // (shell-routing-R12, rbac-R23): подмены доступным проектом нет.
    notFoundInLink: 'The project from the link was not found',
  },
  
  source: {
    dataSources: 'Data Sources',
    statisticsRefreshed: 'Table statistics refreshed',
    addSource: 'Add Data Source',
    addSourceTitle: 'Add New Data Source',
    editSourceTitle: 'Edit Data Source',
    name: 'Source Name',
    namePlaceholder: 'My Database',
    type: 'Database Type',
    host: 'Host',
    port: 'Port',
    database: 'Database Name',
    username: 'Username',
    password: 'Password',
    passwordPlaceholder: 'Leave empty to keep current password',
    testConnection: 'Test Connection',
    testConnectionSuccess: 'Connection successful!',
    testConnectionFailed: 'Connection failed',
    created: 'Source "{name}" created successfully!',
    updated: 'Source "{name}" updated successfully!',
    createError: 'Failed to create source',
    updateError: 'Failed to update source',
    notSynced: 'Not synced',
    // Source sync states shown in the tree node tooltip. Both keys were absent
    // from both locales and the user saw the key itself (i18n-R02).
    synced: 'Synced',
    syncing: 'Sync in progress',
    loadError: 'Failed to load sources',
    // Opening a connection, file pattern, endpoint or topic workspace failed;
    // the key was absent from both locales (BUG-0006, i18n-R02).
    loadFailed: 'Failed to load source data',
    notFound: 'Source not found: {name}',
    syncSuccess: 'Metadata synchronized successfully',
    syncQueued: 'Connection established, sync queued',
    syncError: 'Failed to synchronize metadata',
    refresh: 'Refresh Metadata',
    settings: 'Source Settings',
    selectSourceFirst: 'Please select a source first',
    schema: 'Schema',
    table: 'Table',
    selectTable: 'Select a table to view its columns',
    neverSynced: 'Never synchronized. Click Refresh to load metadata.',
    lastSyncFailed: 'Last sync failed {timeAgo}',
    lastSynced: 'Last synced {timeAgo}',
    justNow: 'just now',
    minutesAgo: '{count}m ago',
    hoursAgo: '{count}h ago',
    daysAgo: '{count}d ago',
    description: 'Source Description',
    descriptionPlaceholder: 'Describe this data source...',
    descriptionEditHint: 'Press Esc to cancel',
    clickToAddDescription: 'Click to add description',
    copyLink: 'Copy source link',
    linkCopied: 'Source link copied',
    linkCopyFailed: 'Failed to copy source link',
    deleteTitle: 'Delete source',
    deleteConfirm: 'Delete source "{name}"? All metadata, notes and tags will be hidden.',
    deleteSuccess: 'Source "{name}" deleted',
    deleteError: 'Failed to delete source',
    noDeletePermission: 'No permission to delete source',
    moreActions: 'More actions',
    schemasTitle: 'Schemas',
    schemasEmpty: 'This source has no schemas',
    schemasHidden: 'Hidden',
    schemasHiddenCount: 'Hidden: {count}',
    schemasNoDescription: 'No description',
    schemasNoTags: 'No tags',
    schemasSearchPlaceholder: 'Search schemas...',
    schemasVisibilityPlaceholder: 'Visibility',
    schemasFilterAll: 'Show all',
    schemasFilterHidden: 'Hidden only',
    schemasFilterVisible: 'Visible only',
    schemasTagsPlaceholder: 'Filter by tags',
    schemaName: 'Schema',
    schemaTables: 'Tables',
    schemaDescription: 'Description',
    schemaTags: 'Tags',
    schemasHide: 'Hide',
    schemasLoadFailed: 'Failed to load source schemas',
    hiddenSchemasLoadFailed: 'Failed to load hidden schemas',
    hiddenSchemasSaveFailed: 'Failed to save hidden schemas',
    schemaNotesLoadFailed: 'Failed to load schema descriptions',
    moveToGroup: {
      action: 'Move to another group',
      title: 'Move source',
      message: 'Select group for source "{name}":',
      selectGroup: 'Select group',
      confirm: 'Move',
      success: 'Source "{name}" moved to group "{group}"',
      noOtherGroups: 'No other groups available',
      error: 'Failed to move the source',
    },
    ssh: {
      tab: 'SSH Tunnel',
      enable: 'Use SSH tunnel',
      host: 'SSH Host',
      port: 'SSH Port',
      username: 'SSH Username',
      authMethod: 'Authentication',
      authPassword: 'Password',
      authPrivateKey: 'Private Key',
      password: 'SSH Password',
      privateKeyPath: 'Private Key Path',
      privateKeyPathPlaceholder: '/home/user/.ssh/id_rsa',
      passphrase: 'Passphrase',
      timeout: 'Connection Timeout (s)',
      keepalive: 'Keep Alive',
      keepaliveInterval: 'Interval (s)',
      testConnection: 'Test SSH',
      testSuccess: 'SSH connection successful!',
      testFailed: 'SSH connection failed',
      passwordPlaceholder: 'Leave empty to keep current',
      advanced: 'Advanced',
    },
    andMoreTables: '...and {count} more',
    tableType: {
      table: 'Table',
      view: 'View',
      materializedView: 'Materialized View',
    },
    odbc: {
      driver: 'ODBC Driver',
      driverPlaceholder: 'Select ODBC driver',
      driverLoading: 'Loading drivers...',
      noDrivers: 'No ODBC drivers found on server',
      template: 'Connection Template',
      templatePlaceholder: 'Select database type',
      templateLoading: 'Loading templates...',
      unavailable: 'ODBC is not available on the server',
    },
    errors: {
      TAG_CODE_EMPTY: 'Tag code cannot be empty',
      TAG_NAME_EMPTY: 'Tag name cannot be empty',
      TAG_COLOR_INVALID: 'Invalid color code: {color}',
      TAG_CODE_EXISTS: 'A tag with code "{code}" already exists in this project',
      ODBC_DRIVER_LIST_FAILED: 'Failed to retrieve ODBC drivers list',
      ODBC_NO_DRIVERS: 'No ODBC drivers installed on the server',
      ODBC_TEMPLATE_NOT_FOUND: 'Connection template "{templateId}" not found',
      ODBC_FIELD_MISSING: 'Required field "{field}" is empty',
      ODBC_FIELD_INVALID: 'Invalid value for field "{field}": {reason}',
      ODBC_BUILD_CONN_STR_FAILED: 'Failed to build connection string',
      ODBC_CONNECT_FAILED: 'ODBC connection failed',
      ODBC_METADATA_FAILED: 'Failed to extract metadata via ODBC',
      ODBC_ENV_INIT_FAILED: 'ODBC is not available on the server',
      SOURCE_NAME_EXISTS: 'A source with this name already exists',
      SOURCE_NAME_EMPTY: 'Source name cannot be empty',
      SOURCE_HOST_EMPTY: 'Source address is required',
      SOURCE_PORT_OUT_OF_RANGE: 'Port must be between {min} and {max}',
      SOURCE_DATABASE_EMPTY: 'Database name is required',
      SOURCE_USERNAME_EMPTY: 'User name is required',
      ODBC_DRIVER_NOT_SELECTED: 'ODBC driver is not selected',
      ODBC_TEMPLATE_NOT_SELECTED: 'Connection template is not selected',
      // Directory traversal is refused in every path value of a source child
      // (spec/backend/data-sources/source-children.md, R14).
      PATH_TRAVERSAL_NOT_ALLOWED:
        'The value must not contain ".." — traversing up the directory tree is not allowed (field: {field})',
      NAME_EXISTS: 'This source already has an object named "{name}"',
      PROVIDER_CONFIG_KEY_UNKNOWN:
        'Unknown parsing setting "{key}". Allowed: {allowed}',
      SOURCE_DB_TYPE_UNSUPPORTED:
        'Connection method "{dbType}" is not supported. Allowed: {allowed}. Other DBMS connect via ODBC',
      SOURCE_SECRET_UNKNOWN:
        'Unknown connection secret "{code}". Allowed: {allowed}',
      ODBC_BUILD_FAILED: 'Failed to build the ODBC connection string',
      GROUP_NAME_EXISTS: 'A group with this name already exists',
      GROUP_HAS_SOURCES: 'Cannot delete group: it has {count} source(s)',
      // Connection type and project of a source are set at creation and cannot
      // change: the type determines what may live under the source
      // (spec/backend/data-sources/connection.md, R24; sources.md, R12).
      SOURCE_CONNECTION_TYPE_IMMUTABLE:
        'The connection type cannot be changed: this source was created as "{currentConnectionType}". Create a new "{connectionType}" source instead',
      SOURCE_PROJECT_IMMUTABLE: 'The project of a source cannot be changed',
      // A source has one connection type: the connection type and the
      // connection method do not point to different types
      // (spec/backend/data-sources/connection.md, R33).
      SOURCE_CONNECTION_TYPE_MISMATCH:
        'Connection type "{connectionType}" does not match connection method "{dbType}": a source has one connection type',
      // Parent kind in the source tree: a connection lives only under a group,
      // a child object only under a connection or another child object of the
      // same source (spec/backend/storage/entities.md, "Иерархия").
      PARENT_MUST_BE_GROUP: 'A connection can only be placed inside a group',
      PARENT_FROM_ANOTHER_SOURCE: 'The selected parent belongs to a different source',
      NOT_FOUND: 'Object not found',
      SSH_AUTH_METHOD_INVALID:
        'Invalid SSH authentication method "{sshAuthMethod}". Allowed: {allowed}',
      SSH_AUTH_METHOD_REQUIRED:
        'SSH authentication method is required when the tunnel is enabled',
      // Password for the "password" method and key path for the
      // "private key" method are required (spec/backend/data-sources/ssh-tunnel.md, R04).
      SSH_PASSWORD_REQUIRED:
        'Enter the SSH password for password authentication',
      SSH_PRIVATE_KEY_PATH_REQUIRED:
        'Enter the private key path for key authentication',
      SSH_TIMEOUT_OUT_OF_RANGE: 'SSH timeout must be between {min} and {max} seconds',
      SSH_KEEPALIVE_INTERVAL_INVALID:
        'SSH keepalive interval must be at least {min} seconds',
      // SSH server address and tunnel user name
      // (spec/backend/data-sources/ssh-tunnel.md, R02, R11).
      SSH_HOST_EMPTY: 'SSH host is required',
      SSH_PORT_OUT_OF_RANGE: 'SSH port must be between {min} and {max}',
      SSH_USERNAME_EMPTY: 'SSH user name is required',
      // Sample data and "Data" tab refusals by reason code
      // (source-explorer-sample-data-R41, R45; api-errors-R04, R08).
      TABLE_ID_FORMAT_INVALID: 'The table is specified incorrectly: a full "schema.table" name is expected',
      SAMPLE_DATA_NOT_CACHED: 'The table data sample has not been loaded yet. Load the sample',
      SOURCE_PASSWORD_NOT_CONFIGURED: 'The source has no connection password. Set the password in the source settings',
      ODBC_CONNECTION_STRING_MISSING: 'The ODBC source has no connection string. Set it in the source settings',
    },
    // Labels of fields the product names in the `field` refusal parameter
    // (api-errors-R06): the refusal text shows the label, not the wire name.
    errorFields: {
      sshPrivateKeyPath: 'Private key path',
    },
    tab: {
      general: 'General',
      ssh: 'SSH Tunnel',
    },
  },

  group: {
    groups: 'Groups',
    addGroup: 'Add Group',
    addGroupTitle: 'Add New Group',
    editGroupTitle: 'Edit Group',
    name: 'Group Name',
    namePlaceholder: 'Enter group name',
    description: 'Description',
    descriptionPlaceholder: 'Group description (optional)',
    sourceCount: '{count} sources',
    deleteConfirm: 'Are you sure you want to delete group "{name}"?',
    created: 'Group "{name}" created',
    updated: 'Group "{name}" updated',
    deleted: 'Group deleted',
    loadError: 'Failed to load groups',
    workspace: {
      sourcesTitle: 'Sources',
      sourcesSearchPlaceholder: 'Search sources...',
      sourcesEmpty: 'This group has no sources',
      sourceName: 'Source',
      sourceSyncStatus: 'Sync Status',
      sourceLastSynced: 'Last Synced',
      sourceSchemaCount: 'Schemas',
      settings: 'Group Settings',
      copyLink: 'Copy group link',
      linkCopied: 'Group link copied',
      linkCopyFailed: 'Failed to copy group link',
      deleteTitle: 'Delete group',
      deleteDisabledHasSources: 'Remove all sources before deleting group',
      descriptionPlaceholder: 'Group description...',
      clickToAddDescription: 'Click to add description',
    },
  },

  schema: {
    notFound: 'Schema not found',
    description: 'Schema Description',
    descriptionPlaceholder: 'Describe this schema...',
    descriptionEditHint: 'Press Esc to cancel',
    clickToAddDescription: 'Click to add description',
    copyLink: 'Copy schema link',
    linkCopied: 'Schema link copied',
    linkCopyFailed: 'Failed to copy schema link',
    tablesTitle: 'Tables',
    tablesEmpty: 'No tables in this schema',
    tablesShowHidden: 'Show hidden',
    tablesHide: 'Hide',
    tablesHidden: 'Hidden',
    tablesHiddenCount: 'Hidden: {count}',
    tablesNoDescription: 'No description',
    tablesNoTags: 'No tags',
    tablesSearchPlaceholder: 'Search tables...',
    tablesVisibilityPlaceholder: 'Visibility',
    tablesFilterAll: 'Show all',
    tablesFilterHidden: 'Only hidden',
    tablesFilterVisible: 'Visible only',
    tablesTagsPlaceholder: 'Filter by tags',
    tableName: 'Table',
    tableColumns: 'Columns',
    tableDescription: 'Description',
    tableTags: 'Tags',
    tablesLoadFailed: 'Failed to load schema tables',
    hiddenTablesLoadFailed: 'Failed to load hidden tables',
    hiddenTablesSaveFailed: 'Failed to save hidden tables',
    tableNotesLoadFailed: 'Failed to load table descriptions',
    batchSelected: 'Selected: {count}',
    batchSelectPage: 'Select page',
    batchSelectAll: 'Select all ({count})',
    batchClear: 'Clear',
    batchHide: 'Hide',
    batchUnhide: 'Unhide',
    batchAddTag: 'Add tag',
    batchRemoveTag: 'Remove tag',
    batchTagsUpdateFailed: 'Failed to update table tags',
  },
  
  table: {
    schemaUnknown: 'The table schema is unknown — data is not loaded',
    hasPk: 'Has PK',
    pk: 'PK',
    fk: 'FK',
    columns: 'Columns',
    rowsEst: 'Rows (est.)',
    columnName: 'Column Name',
    dataType: 'Data Type',
    nullable: 'Nullable',
    dbComment: 'DB Comment',
    noComment: 'No comment',
    analystNote: 'Analyst Note',
    addNote: 'Add note',
    clickToAddNote: 'Click to add note...',
    noteEditPlaceholder: 'Enter your note... (supports formatting)',
    noteEditHint: 'Use toolbar for formatting. Click outside to save.',
    noteSaved: 'Note saved successfully',
    columnsSelected: 'columns selected',
    selectAll: 'Select All',
    clearSelection: 'Clear Selection',
    appendNote: 'Append Note',
    batchAppendNoteTitle: 'Append Note to Selected Columns',
    batchNotePlaceholder: 'Enter text to append to all selected columns...',
    appendToSelected: 'Append to {count} columns',
    batchNotesSaved: 'Notes appended to {count} columns',
    batchNotesSaveFailed: 'Failed to append notes',
    allColumnsReviewed: 'All columns reviewed!',
    allColumnsReviewedDesc: 'Every column in this table has analyst notes. Great job!',
    tableDescriptionPlaceholder: 'Describe the purpose and business context of this table...',
    addTableDescription: 'Click to add table description',
    editTableNoteHint: 'Press Esc to cancel',
    tableNoteSaved: 'Table description saved',
    notNull: 'NOT NULL',
    yes: 'YES',
    notFoundInCache: 'Table metadata not found in cache',
    loadFailed: 'Failed to load table',
    copyLink: 'Copy Link',
    linkCopied: 'Link copied to clipboard',
    linkCopyFailed: 'Failed to copy link',
    tabs: {
      columns: 'Columns',
      schema: 'Schema',
      indexes: 'Indexes',
      constraints: 'Constraints',
      data: 'Data',
    },
    schemaEmpty: 'No relations found',
    schemaLoadFailed: 'Failed to load table schema',
    schemaPartialLoadFailed: 'Some related tables failed to load',
    schemaRenderFailed: 'Failed to render diagram',
    schemaRelationsTitle: 'Outgoing Relations',
    schemaIncomingRelationsTitle: 'Incoming Relations',
    schemaDiagramTitle: 'Relations Diagram',
    schemaRelations: {
      constraintName: 'Constraint Name',
      sourceColumn: 'Source Column',
      targetTable: 'Target Table',
      targetColumn: 'Target Column',
    },
    schemaIncomingRelations: {
      constraintName: 'Constraint Name',
      sourceTable: 'Source Table',
      sourceColumn: 'Source Column',
      targetColumn: 'Target Column',
    },
    indexes: {
      name: 'Index Name',
      type: 'Type',
      columns: 'Columns',
      isUnique: 'Unique',
      isPrimary: 'Primary',
      predicate: 'Predicate (WHERE)',
      unique: 'UNIQUE',
      primary: 'PRIMARY',
      empty: 'No indexes found',
      loadFailed: 'Failed to load indexes',
    },
    constraints: {
      name: 'Constraint Name',
      type: 'Type',
      columns: 'Columns',
      referencedTable: 'Referenced Table',
      referencedColumns: 'Referenced Columns',
      definition: 'Definition',
      empty: 'No constraints found',
      loadFailed: 'Failed to load constraints',
    },
    dataTab: {
      whereLabel: 'WHERE',
      orderByLabel: 'ORDER BY',
      apply: 'Load data',
      clear: 'Clear',
      errorTitle: 'Query execution error',
    },
  },
  
  coverage: {
    reviewProgress: 'Review Progress',
    total: 'Total',
    withNotes: 'With Notes',
    needsReview: 'Needs Review',
    pii: 'PII',
    noDbComment: 'No DB Comment',
    changed: 'Changed',
  },
  
  filter: {
    title: 'Filters',
    withNotes: 'With Notes',
    withoutNotes: 'Without Notes',
    withDbComment: 'With DB Comment',
    noDbComment: 'No DB Comment',
    keys: 'Keys (PK/FK)',
    primaryKey: 'Primary Key',
    foreignKey: 'Foreign Key',
    reviewMode: 'Review Mode',
    clearAll: 'Clear All',
  },

  comments: {
    title: 'Comments',
    empty: 'No comments yet',
    placeholder: 'Write a comment...',
    add: 'Add comment',
    retry: 'Retry',
    loadFailed: 'Failed to load comments',
    createFailed: 'Failed to add comment',
    /** Refusal texts by reason code (comments-R11, i18n-R06). */
    errors: {
      COMMENT_BODY_EMPTY: 'A comment cannot be empty',
      COMMENT_AUTHOR_NOT_ACCEPTED: 'The comment author is set by the product and is not accepted in the request',
      COMMENT_ENTITY_NAME_AMBIGUOUS: 'The object name is ambiguous: the source has several objects with this name',
      AUTHENTICATION_REQUIRED: 'Sign in to leave a comment',
      NOT_FOUND: 'The discussed object was not found',
      NETWORK_ERROR: 'Failed to load comments: no connection to the server',
    },
  },

  tags: {
    title: 'Tags',
    placeholder: 'Tags',
    loadFailed: 'Failed to load tags',
    saveFailed: 'Failed to save tags',
  },
  
  auth: {
    userMenu: 'User menu',
    errors: {
      INVALID_CREDENTIALS: 'Current password is incorrect',
      PASSWORD_TOO_WEAK: 'Password is too weak: at least 8 characters',
      NEW_PASSWORD_SAME_AS_OLD: 'The new password matches the old one',
    },
    profileLoadFailed: 'Failed to refresh the profile. Please retry later',
    sectionForbidden: 'This section is available to the product administrator only',
    loginTitle: 'Sign In',
    login: 'Login',
    loginOrEmail: 'Login or Email',
    logout: 'Logout',
    logoutAll: 'Logout everywhere',
    profile: 'Profile',
    password: 'Password',
    changePassword: 'Change Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    mustChangePasswordWarning: 'You are using a temporary password. Please change it.',
    passwordChanged: 'Password successfully changed',
    invalidCredentials: 'Invalid login/email or password',
    sessionExpired: 'Session expired. Please login again.',
    loginSuccess: 'Login successful',
    loginError: 'Login error',
    identifierRequired: 'Please enter login or email',
    passwordRequired: 'Please enter password',
    oldPasswordRequired: 'Please enter old password',
    newPasswordRequired: 'Please enter new password',
    confirmPasswordRequired: 'Please confirm new password',
    passwordTooShort: 'Password must be at least {min} characters',
    passwordMustBeDifferent: 'New password must be different from old password',
    passwordsDoNotMatch: 'Passwords do not match',
    invalidOldPassword: 'Invalid old password',
    changePasswordError: 'Error changing password',
  },
  
  sampleData: {
    title: 'Sample Data',
    rows: 'rows',
    cached: 'Cached',
    refresh: 'Refresh sample data',
    export: 'Export to CSV',
    loading: 'Loading sample data...',
    noData: 'No sample data available',
    loadData: 'Load Sample Data',
    justNow: 'just now',
    minutesAgo: '{n}m ago',
    hoursAgo: '{n}h ago',
    daysAgo: '{n}d ago',
    errorTitle: 'Error loading data',
    retry: 'Retry',
  },
  
  sourceExplorer: {
    // Attempts-exhausted mark — NOT a failure-cause code, an addition to the
    // cause text (data-processing-metadata-sync-R08,
    // source-explorer-profiling-R07; api-errors-R07).
    errorAttemptsExhausted: 'All retries used',
    columnProfile: {
      title: 'Column Profile',
      loading: 'Profiling in progress...',
      loadingHint: 'For large tables this may take a few minutes',
      error: 'Failed to load profile',
      timeout: 'Profile loading timeout. Try again or check if the table is too large.',
      refresh: 'Refresh',
      retry: 'Retry',
      notProfiled: 'Not profiled yet',
      startProfiling: 'Profile',
      enqueued: 'Profiling started. Please wait...',
      totalRows: 'Total Rows',
      nonNull: 'Non-Null',
      nullPercent: 'Null %',
      distinctCount: 'Distinct Values',
      numericStats: 'Numeric Statistics',
      min: 'Min',
      max: 'Max',
      avg: 'Average',
      median: 'Median',
      stddev: 'Std Deviation',
      textStats: 'Text Statistics',
      minLength: 'Min Length',
      maxLength: 'Max Length',
      avgLength: 'Avg Length',
      profiledAt: 'Profiled at',
      topValues: 'Top 10 Values',
      value: 'Value',
      count: 'Count',
      percentage: 'Percentage',
    },
    profiling: {
      title: 'Profiling',
      refresh: 'Refresh',
      settingsTitle: 'Profiling Settings',
      maxConcurrent: 'Concurrent tasks',
      windowStart: 'Window from',
      windowEnd: 'to',
      saveSettings: 'Save',
      timeHint: 'Time is shown in local time',
      queueTitle: 'Profiling Queue',
      historyTitle: 'Profiling History',
      queueEmpty: 'Queue is empty',
      historyEmpty: 'History is empty',
      schema: 'Schema',
      table: 'Table',
      column: 'Column',
      status: 'Status',
      createdAt: 'Created',
      startedAt: 'Started',
      completedAt: 'Completed',
      duration: 'Duration',
      error: 'Error',
      statusPending: 'Pending',
      statusProcessing: 'Processing',
      statusCompleted: 'Completed',
      statusFailed: 'Failed',
      queueLoadFailed: 'Failed to load profiling queue',
      historyLoadFailed: 'Failed to load profiling history',
      settingsLoadFailed: 'Failed to load profiling settings',
      settingsSaveFailed: 'Failed to save profiling settings',
      settingsSaved: 'Profiling settings saved',
    },
    metadataSync: {
      title: 'Metadata Synchronization',
      refresh: 'Refresh Data',
      currentTask: 'Current Task',
      // A task state, NOT a failure-cause code: a restart returning the task to
      // the queue is not a failure — the attempt is not spent and the task runs
      // again (api-errors-R12, data-processing-metadata-sync-R10). Hence the
      // text lives here and not in the `errors.` namespace.
      returnedAfterRestart: 'The task was returned to the queue after a service restart and will run again',
      historyTitle: 'Sync History',
      empty: 'No sync tasks',
      historyEmpty: 'Sync history is empty',
      status: 'Status',
      startedAt: 'Started',
      completedAt: 'Completed',
      duration: 'Duration',
      schemas: 'Schemas',
      tables: 'Tables',
      columns: 'Columns',
      error: 'Error',
      statusPending: 'Pending',
      statusProcessing: 'Processing',
      statusCompleted: 'Completed',
      statusFailed: 'Failed',
      queueLoadFailed: 'Failed to load sync queue',
      historyLoadFailed: 'Failed to load sync history',
      queued: 'Metadata sync has been queued',
    },
  },

  versioning: {
    commit: 'Commit',
    history: 'History',
    loadHistoryError: 'Failed to load history',
    commitTitle: 'Create Commit',
    commitMessage: 'Commit Message',
    commitMessagePlaceholder: 'Describe changes (optional)',
    commitSuccess: 'Commit created successfully',
    commitError: 'Failed to create commit',
    historyTitle: 'Commit History',
    noHistory: 'No commits yet',
    noMessage: 'No description',
    checkout: 'Checkout',
    checkoutTitle: 'Create Branch',
    branchName: 'Branch Name',
    branchNamePlaceholder: 'Enter new branch name',
    branchNameHint: 'Leave empty for auto-generated name',
    checkoutSuccess: 'Branch created successfully',
    checkoutError: 'Failed to create branch',
    by: 'by',
    // Versioning failures reach the user as their reason (api-errors-R08, BUG-0071);
    // each operation has its own failure texts (BUG-0073).
    checkoutFailure: {
      errors: {
        ACCESS_DENIED: 'You do not have permission to create a branch',
      },
    },
    commitFailure: {
      errors: {
        ACCESS_DENIED: 'You do not have permission to create a commit',
        // business-model-versioning-R04, R29.
        FEATURE_NOT_HEAD: 'An archived feature cannot be committed: only a HEAD feature can be committed',
      },
    },
    // api-errors-R09, R08 (BUG-0075).
    historyFailure: {
      errors: {
        ACCESS_DENIED: 'You do not have permission to view the version history',
      },
    },
  },

  feature: {
    createStandalone: 'create feature',
    select: 'Feature',
    create: 'Create Feature...',
    createTitle: 'Create Feature',
    name: 'Feature Name',
    namePlaceholder: 'Enter feature name',
    description: 'Description',
    descriptionPlaceholder: 'Enter feature description',
    created: 'Feature "{name}" created',
    loadError: 'Failed to load features',
    createError: 'Failed to create feature',
    selectProjectFirst: 'Please select a project first',
    // Фича из ссылки не принадлежит проекту адреса: открыта другая, и об этом
    // сообщается — молчаливого переноса выбора между проектами нет
    // (shell-routing-R12, features-R10).
    notInLinkProject:
      'The feature from the link is unavailable in this project — another one is open',
    manageTitle: 'Project features',
    listEmpty: 'The project has no features',
    selected: 'selected',
    showArchived: 'Show archived',
    restore: 'Restore from archive',
    restoreTitle: 'Restore feature from archive',
    restored: 'Feature "{name}" restored from archive',
    properties: 'Properties',
    propertiesTitle: 'Feature properties',
    status: 'Status',
    statuses: {
      draft: 'Draft',
      in_progress: 'In progress',
      review: 'Review',
      merged: 'Merged',
      archived: 'Archived',
    },
    saved: 'Changes saved',
    deleteTitle: 'Delete feature "{name}"?',
    deleteCascade: 'The feature\'s business model and mappings will be deleted along with it.',
    deleteIrreversible: 'This action is irreversible: the feature cannot be restored, and undo does not roll the deletion back.',
    deleteArchiveHint: 'To hide the feature while keeping its content, set its status to "Archived" instead of deleting it.',
    deleted: 'Feature "{name}" deleted',
  },

  markdownEditor: {
    preview: 'Preview',
    previewTooltip: 'Show the note the way others will see it',
    previewEmpty: 'The note is empty',
    formatHint: 'Notes are written in Markdown. HTML markup is not accepted; to show it as an example, put it in code.',
    boldTooltip: 'Bold',
    boldPlaceholder: 'bold text',
    italicTooltip: 'Italic',
    italicPlaceholder: 'italic',
    strikeTooltip: 'Strikethrough',
    strikePlaceholder: 'struck out text',
    codeTooltip: 'Code',
    codePlaceholder: 'code',
    headingTooltip: 'Heading',
    bulletListTooltip: 'Bulleted list',
    orderedListTooltip: 'Numbered list',
    quoteTooltip: 'Quote',
    linkTooltip: 'Insert link',
    linkLabel: 'link',
    promptEnterLinkUrl: 'Enter the link URL:',
    imageLabel: 'image',
    imageSizeExceeded: 'Image size should not exceed 5MB',
    invalidImageFile: 'Please upload an image file',
    imageReadFailed: 'Failed to read image',
    uploadImageTooltip: 'Upload image',
    insertImageUrlTooltip: 'Insert image from URL',
    promptEnterImageUrl: 'Enter image URL:',
  },

  richTextEditor: {
    imageSizeExceeded: 'Image size should not exceed 5MB',
    invalidImageFile: 'Please upload an image file',
    imageReadFailed: 'Failed to read image',
    uploadImageTooltip: 'Upload image',
    insertImageUrlTooltip: 'Insert image from URL',
    promptEnterImageUrl: 'Enter image URL:',
  },

  bm: {
    packages: {
      confirmDeletePackage: 'Delete package "{name}" and all its contents?',
      confirmDeleteDiagram: 'Delete diagram "{name}"?',
      deletePackageTitle: 'Delete package',
      deleteDiagramTitle: 'Delete diagram',
    },
    tree: {
      title: 'Packages & diagrams',
      // Отказ группового перемещения называет узел, на котором он произошёл
      // (business-model-packages-R21, R22).
      moveNodeFailed: 'Failed to move "{name}"',
      contextMenu: {
        createPackage: 'Create package',
        createDiagram: 'Create diagram',
        createClass: 'Create class',
        rename: 'Rename',
        delete: 'Delete',
        editClass: 'Edit',
        renameClass: 'Rename',
        deleteClass: 'Delete class',
        confirmDeleteClass: 'Delete class "{name}"? This action cannot be undone.',
        deleteClassTitle: 'Delete class',
      },
    },
    toolbar: {
      createClass: 'Create class',
      className: 'Class',
      undo: 'Undo (Ctrl+Z)',
      redo: 'Redo (Ctrl+Shift+Z)',
      save: 'Save (Ctrl+S)',
      saveName: 'Save',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      fitView: 'Fit to screen',
      unlock: 'Unlock',
      lock: 'Lock',
      hideMinimap: 'Hide minimap',
      showMinimap: 'Show minimap',
      disableSnapToGrid: 'Disable snap to grid',
      enableSnapToGrid: 'Enable snap to grid',
      exportPng: 'Export to PNG',
      exportSuccess: 'Diagram exported',
      exportError: 'Failed to export diagram',
    },
    hiddenEdges: 'Has hidden edges',
    noFields: 'No fields',
    noValues: 'No values',
    canvas: {
      loadingGraph: 'Loading graph...',
      openDiagramHint: 'Open a diagram from the list on the left',
    },
    contextMenu: {
      createClass: 'Create class',
      showAllEdges: 'Show all edges',
      removeFromDiagram: 'Remove from diagram',
      deleteClass: 'Delete class',
      hideEdge: 'Hide edge',
    },
    diagram: {
      defaultName: 'the diagram',
      saveError: 'Diagram save error',
      changesSaved: 'Changes saved',
      noDiagramSelected: 'No diagram selected',
      classAlreadyOnDiagram: 'Class is already on diagram',
      unsavedChangesConfirm: 'Diagram "{name}" has unsaved changes.\n\nSave changes before closing?',
      classCreatedLocally: 'Class created locally. Save your changes.',
      changesLocalSave: 'Changes saved locally. Save the diagram.',
      classCreated: 'Class created',
      createClassError: 'Failed to create class',
    },
    errors: {
      MISSING_SOURCE_ID: 'No source is selected. Select a source and retry',
      // Sample panel and Data tab localize a sampling refusal by its reason
      // code (source-explorer-sample-data-R16, R41; api-errors-R08).
      TABLE_NAME_AMBIGUOUS: 'The table name "{entityId}" is ambiguous: the source has several tables with this full name',
      FIELD_TYPE_NOT_SELECTED: 'Field "{field}" has no type selected: the class was not saved',
      // Refusals of the composite "class together with its fields" action
      // (classes-R25, R26): a failure of any part refuses the whole action and
      // the user sees its own cause, not a generic text (api-errors-R05, R08).
      CLASS_NAME_EXISTS: 'A class named "{name}" already exists in this feature',
      CLASS_NAME_EMPTY: 'Class name cannot be empty',
      FIELD_NAME_EXISTS: 'A field named "{name}" already exists in this class: the class was not saved',
      FIELD_NAME_EMPTY: 'Field name cannot be empty: the class was not saved',
      ENUM_VALUE_EXISTS: 'Value "{value}" already exists in this enum: the class was not saved',
      ENUM_VALUE_EMPTY: 'Enum value cannot be empty: the class was not saved',
      CLASS_TYPE_CANNOT_HAVE_FIELDS: 'A class of this type has no fields',
      CLASS_IS_NOT_ENUM: 'Only an enum has enum values',
      DIAGRAM_FROM_ANOTHER_FEATURE: 'Diagram "{name}" belongs to another feature — the class cannot be placed on it',
      MIN_CARDINALITY_NEGATIVE: 'Minimum cardinality cannot be negative',
      MAX_CARDINALITY_LESS_THAN_MIN: 'Maximum cardinality cannot be less than the minimum',
      CLASS_INHERITANCE_CYCLE: 'A class cannot become its own ancestor: that would close the inheritance into a loop',
      CLASS_HAS_CHILDREN: 'Cannot delete class: has {count} child classes',
      CLASS_HAS_REFERENCES: 'Cannot delete class: referenced by {count} fields',
      // Удаление пакета с классами в нём или в подпакетах блокируется
      // (spec/backend/business-model/packages.md, business-model-packages-R25).
      PACKAGE_HAS_CLASSES: 'Cannot delete package: it or its subpackages contain classes',
      CANNOT_DELETE_PRIMITIVE: 'Cannot delete primitive type',
      CANNOT_CREATE_PRIMITIVE: 'Cannot create primitive types',
      CANNOT_MODIFY_PRIMITIVE: 'Primitive type is a platform constant and cannot be modified',
      ENUM_CANNOT_CHANGE_TYPE: 'Enum type cannot be changed',
      PRIMITIVE_CANNOT_CHANGE_TYPE: 'Primitive type cannot be changed',
      INVALID_TYPE_CHANGE: 'Invalid class type change',
      EXTENSION_CANNOT_BE_ABSTRACT: 'Extension cannot be abstract',
      ENUM_CANNOT_BE_ABSTRACT: 'Enum cannot be abstract',
      ONLY_CONCRETE_CAN_HAVE_PARENT: 'Only classes can have a parent',
      PARENT_MUST_BE_ABSTRACT: 'Parent must be an abstract class',
      PRIMITIVE_CANNOT_BE_REFERENCE: 'Primitive type cannot be a reference',
      // Feature isolation: a reference of a feature object points only within
      // the same feature (spec/backend/invariants/feature-isolation.md, R01, R04, R06).
      PACKAGE_FROM_ANOTHER_FEATURE: 'Package "{name}" belongs to another feature — the object cannot be placed in it',
      PARENT_PACKAGE_FROM_ANOTHER_FEATURE: 'Package "{name}" belongs to another feature and cannot be its parent',
      PARENT_CLASS_FROM_ANOTHER_FEATURE: 'Class "{name}" belongs to another feature — it cannot become the parent',
      TYPE_CLASS_FROM_ANOTHER_FEATURE: 'The type class of the field belongs to another feature',
      EDGE_FIELD_FROM_ANOTHER_FEATURE: 'Field "{name}" belongs to another feature — its edge cannot be hidden on this diagram',
      // Размещаемый класс принадлежит фиче диаграммы
      // (spec/backend/business-model/diagrams.md, business-model-diagrams-R55).
      CLASS_FROM_ANOTHER_FEATURE: 'Class "{name}" belongs to another feature — it cannot be placed on this diagram',
      EDGE_CLASS_FROM_ANOTHER_FEATURE: 'Class "{name}" belongs to another feature — its edge cannot be hidden on this diagram',
      CLASS_NOT_FOUND: 'Class not found',
      FIELD_NOT_FOUND: 'Field not found',
      ENUM_VALUE_NOT_FOUND: 'Enum value not found',
      DELETE_FAILED: 'Failed to delete',
      CREATE_FAILED: 'Failed to create',
      UPDATE_FAILED: 'Failed to update',
      LOAD_FAILED: 'Failed to load the business model',
      UNKNOWN_ERROR: 'Unknown error',
    },
    export: {
      // Итог выгрузки с предупреждениями (export-R10, R11)
      completedWithWarnings: 'Exported with warnings',
      warningDiagram: 'could not obtain the image of diagram {name}',
      warningPackage: 'could not obtain the diagrams of package {name}',
      button: 'Export documentation',
      title: 'Export documentation',
      progress: 'Exporting: {progress}%',
      success: 'Documentation exported successfully',
      error: 'Failed to export documentation',
      exporting: 'Exporting...',
      // Labels of the exported bundle: it is a user-facing surface of the
      // product, so its texts come from the dictionaries in the language of the
      // export (export-R27, i18n-R02). Model object names are not translated.
      document: {
        heading: '{name} model documentation',
        generatedBy: 'Generated by MetaBridge',
        navigation: 'Navigation tree',
        searchPlaceholder: 'Search by name',
        searchAction: 'Search',
        nodeExpand: 'Expand node',
        nodeCollapse: 'Collapse node',
        searchEmpty: 'Nothing found',
        diagrams: 'Diagrams',
        subPackages: 'Sub-packages',
        classes: 'Classes',
        documentation: 'Documentation',
        generalization: 'Generalization',
        inheritors: 'Inheritors',
        enumValues: 'Enum values',
        attributes: 'Attributes',
        abstract: 'abstract',
        columnValue: 'Value',
        columnDocumentation: 'Documentation',
        columnName: 'Name',
        columnType: 'Type',
        columnCardinality: 'Cardinality',
      },
      steps: {
        fetchingGraph: 'Fetching graph...',
        fetchingPackages: 'Fetching packages...',
        generatingHtml: 'Generating HTML...',
        creatingZip: 'Creating archive...',
        generatingPackages: 'Generating package pages...',
        downloading: 'Downloading...',
      },
    },
  },

  admin: {
    users: {
      title: 'Users',
      fullName: 'Full Name',
      login: 'Login',
      email: 'Email',
      role: 'Role',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      isAdmin: 'Administrator',
      editUser: 'Edit User',
      resetPassword: 'Reset Password',
      newPassword: 'New Password',
      mustChangePassword: 'Require change on login',
      saveSuccess: 'User updated',
      resetSuccess: 'Password reset',
      cannotDeactivateSelf: 'Cannot deactivate yourself',
      createUser: 'Create User',
      createSuccess: 'User created',
      password: 'Password',
      passwordHint: 'At least {min} characters',
      blockUser: 'Block',
      unblockUser: 'Unblock',
      userBlocked: 'User blocked',
      userUnblocked: 'User unblocked',
      blockTitle: 'Block user “{login}”?',
      blockExplanation: 'The user will lose access to the product.',
      validation: {
        required: 'Required field',
        login: 'Invalid login format',
        password: 'At least 8 characters',
      },
      errors: {
        ACCESS_DENIED: 'Access denied',
        USER_NOT_FOUND: 'User not found',
        CANNOT_DEACTIVATE_SELF: 'Cannot deactivate yourself',
        PASSWORD_TOO_WEAK: 'Password too weak',
        LOGIN_ALREADY_EXISTS: 'Login already exists',
        EMAIL_ALREADY_EXISTS: 'Email already exists',
        INVALID_LOGIN_FORMAT: 'Login may only contain lowercase letters, digits, _ and -',
        UNKNOWN_ERROR: 'Unknown error',
      },
    },
  },

  connection: {
    types: {
      database: 'Database',
      ftp: 'FTP',
      sftp: 'SFTP',
      s3: 'S3',
      local_path: 'Local Path',
      webapi: 'Web API',
      kafka: 'Kafka',
    },
    dataProviders: {
      database: 'Database',
      excel: 'Excel',
      csv: 'CSV',
      json: 'JSON',
      xml: 'XML',
    },
    addGroup: 'Add Group',
    addConnection: 'Add Connection',
    connectionType: 'Connection Type',
    dataProvider: 'Data Provider',
    testConnection: 'Test Connection',
    addChildItem: 'Add Item',
    s3: {
      bucket: 'Bucket',
      region: 'Region',
      accessKey: 'Access Key',
      secretKey: 'Secret Key',
    },
    webApi: {
      baseUrl: 'Base URL',
      authType: 'Auth Type',
      authNone: 'None',
      authBearer: 'Bearer Token',
      authBasic: 'Basic Auth',
      authApiKey: 'API Key',
      tokenKey: 'Token / Key',
      headerName: 'Header Name',
    },
    kafka: {
      brokers: 'Brokers',
      securityProtocol: 'Security Protocol',
      plaintext: 'Plaintext',
      ssl: 'SSL',
      saslSsl: 'SASL_SSL',
      saslPlaintext: 'SASL_PLAINTEXT',
      saslMechanism: 'SASL Mechanism',
      schemaRegistryUrl: 'Schema Registry URL',
    },
  },

  filePattern: {
    filePatterns: 'File Patterns',
    name: 'Name',
    fileMask: 'File Mask',
    filePath: 'File Path',
    addFilePattern: 'Add File Pattern',
    addTitle: 'Add File Pattern',
    fileMaskPlaceholder: '*.csv, report_*.xlsx',
    filePathPlaceholder: '/data/reports',
    dataProvider: 'Data Format',
    delimiter: 'Delimiter',
    encoding: 'Encoding',
    headerRow: 'Header Row',
    deleteConfirm: 'Delete file pattern "{name}"?',
  },

  endpoint: {
    endpoints: 'Endpoints',
    name: 'Name',
    method: 'HTTP Method',
    path: 'Path',
    addEndpoint: 'Add Endpoint',
    addTitle: 'Add Endpoint',
    methodPlaceholder: 'GET',
    pathPlaceholder: '/api/users',
    deleteConfirm: 'Delete endpoint "{name}"?',
  },

  topic: {
    topics: 'Topics',
    name: 'Name',
    topicName: 'Topic Name',
    addTopic: 'Add Topic',
    addTitle: 'Add Topic',
    topicNamePlaceholder: 'events.orders',
    deleteConfirm: 'Delete topic "{name}"?',
  },

  undoRedo: {
    undo: 'Undo',
    redo: 'Redo',
    nothingToUndo: 'Nothing to undo',
    nothingToRedo: 'Nothing to redo',
    undoFailed: 'Failed to undo action',
    redoFailed: 'Failed to redo action',
    conflict: 'Conflict: the change was affected by a later edit',
    /** Refusal texts by reason code (undo-redo-R19, i18n-R06). */
    errors: {
      // Отмена и возврат доступны только при выбранной фиче (versioning-R21)
      FEATURE_NOT_SELECTED: 'No feature selected',
      NOTHING_TO_UNDO: 'Nothing to undo',
      NOTHING_TO_REDO: 'Nothing to redo',
      CONFLICT: 'Conflict: the change was affected by a later edit',
      SESSION_NOT_FOUND: 'Edit session not found',
      SESSION_CLOSED: 'Edit session is closed',
      ACCESS_DENIED: 'You do not have permission to undo this change',
      STORAGE_ERROR: 'Undo failed',
      NETWORK_ERROR: 'Undo failed: no connection to the server',
    },
  },
};
